import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

// Components
import CardMemberAvatar from '@atoms/CardMemberAvatar';
import { BodySmall, H4 } from '@styled';
import { Link } from 'react-router-dom';

// Functionality
import { generateSavedSearchTitle } from '../../../../icsc-app/js/helpers/savedSearches.helpers';
import colors from '@general/colors';
import { getMemberFullName } from '@general/entities/member';
import { getDisplaySize } from '@general/entities/property';
import { capitalize } from '@general/utility';
import { ProductsStrings } from '@general/helpers/SavedSearchesQuestionStrings';

const CardOuterStyled = styled.div`
    border-top: 6px solid ${colors.emerald};
`;

const SavedSearchCard = ({ savedSearch, member, linkToMemberProfile = false }) => {
    const [memberName, setMemberName] = useState();

    useEffect(() => {
        if (!member) {
            return;
        }

        const { firstName, lastName } = member;
        setMemberName(getMemberFullName(firstName, lastName));
    }, [member]);

    return (
        <CardOuterStyled className="card mb-0" style={{ height: '100%', flexGrow: 1 }}>
            <div className="p-4">
                <H4>{generateSavedSearchTitle(savedSearch)}</H4>

                {savedSearch.businessLocations && (
                    <>
                        <BodySmall className="mt-3 font-bold">Regions</BodySmall>
                        <BodySmall className="mt-2">
                            {savedSearch.businessLocations.map(location => capitalize(location)).join(', ')}
                        </BodySmall>
                    </>
                )}

                {/* Space */}
                {savedSearch.space?.purpose && (
                    <>
                        <BodySmall className="mt-3 font-bold">Purpose of Space</BodySmall>
                        <BodySmall className="mt-2">{capitalize(savedSearch.space.purpose.join(', '))}</BodySmall>
                    </>
                )}
                {savedSearch.space?.typeOfCenter && (
                    <>
                        <BodySmall className="mt-3 font-bold">Type of Space</BodySmall>
                        <BodySmall className="mt-2">{capitalize(savedSearch.space.typeOfCenter.join(', '))}</BodySmall>
                    </>
                )}
                {savedSearch.space?.density && (
                    <>
                        <BodySmall className="mt-3 font-bold">Population Density</BodySmall>
                        <BodySmall className="mt-2">{capitalize(savedSearch.space.density.join(', '))}</BodySmall>
                    </>
                )}
                {savedSearch.space?.typeOfFacility && (
                    <>
                        <BodySmall className="mt-3 font-bold">Type of Facility</BodySmall>
                        <BodySmall className="mt-2">
                            {capitalize(savedSearch.space.typeOfFacility.join(', '))}
                        </BodySmall>
                    </>
                )}
                {savedSearch.space?.size && (
                    <>
                        <BodySmall className="mt-3 font-bold">Size</BodySmall>
                        <BodySmall className="mt-2">
                            {savedSearch.space.size.map(size => getDisplaySize(size)).join(', ')}
                        </BodySmall>
                    </>
                )}

                {/* Product */}
                {savedSearch.products?.productTypes && (
                    <>
                        <BodySmall className="mt-3 font-bold">Products & Services</BodySmall>
                        <BodySmall className="mt-2">
                            {savedSearch.products?.productTypes
                                .map(productType => ProductsStrings.productTypes[`${productType.toUpperCase()}`])
                                .join(', ')}
                        </BodySmall>
                    </>
                )}

                <div className="d-flex flex-row mt-4 align-items-center">
                    <CardMemberAvatar
                        firstName={member.firstName}
                        lastName={member.lastName}
                        fullName={memberName}
                        photoURL={member.photoUrl}
                        sizeDesktop={26}
                    />

                    <BodySmall style={{ marginLeft: '10px' }}>
                        {linkToMemberProfile && (
                            <Link
                                className="font-bold text-azure"
                                to={{
                                    pathname: `/member/profile/${member.id}`,
                                    state: { graphID: btoa(`01:Member${member.id}`) },
                                }}
                            >
                                {memberName}
                            </Link>
                        )}

                        {!linkToMemberProfile && <>{memberName}</>}
                    </BodySmall>
                </div>
            </div>
        </CardOuterStyled>
    );
};

SavedSearchCard.propTypes = {
    savedSearch: PropTypes.object,
    member: PropTypes.object,
    linkToMemberProfile: PropTypes.bool,
};

export default SavedSearchCard;
